module.exports = __webpack_public_path__ + "img/logo.aaf835bc.png";